import {analytics} from "../services/analytics";

/**
 * Set up global error handlers for unhandled errors and promise rejections
 */
export function setupGlobalErrorHandlers() {
  // Handle uncaught errors
  window.addEventListener("error", (event) => {
    analytics.captureException(event.error || new Error(event.message), {
      source: "window.onerror",
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      platform: typeof window !== "undefined" && window.api ? "desktop" : "web",
    });
  });

  // Handle unhandled promise rejections
  window.addEventListener("unhandledrejection", (event) => {
    analytics.captureException(
      new Error(`Unhandled Promise Rejection: ${event.reason}`),
      {
        source: "unhandledrejection",
        reason: event.reason,
        promise: event.promise,
        platform:
          typeof window !== "undefined" && window.api ? "desktop" : "web",
      }
    );
  });
}
